export enum AuthMutationTypes {
  SET_AUTH = "SET_AUTH",
  DELETE_AUTH = "DELETE_AUTH",
  UPDATE_ERROR = "UPDATE_ERROR",
  UPDATE_FETCHING_CURRENT_USER = "UPDATE_FETCHING_CURRENT_USER",
}
